module.exports = __webpack_public_path__ + "img/feature-icon1.7b4ac889.png";